<template>
  <section class="top-publicity">
    <p class="tip">
      实体卡老平台用户
      <br>
      <a href="http://k.kezhu.net" target="_blanket">点击这里</a>
    </p>
    <div class="content">
      &emsp;结盟连锁，创始第 1 期 100 酒店招募中————
      <img src="@/assets/img/click.png" alt="">
    </div>
  </section>
</template>

<script>
export default {
  name: 'Publicity'
}
</script>

<style lang="scss" scoped>
.top-publicity {
  width: 1200px;
  height: 60px;
  margin: 0 auto;
  display: grid;

  .tip {
    font-size: 13px;
    text-align: center;
    line-height: 16px;
    border: 1.1px solid #000;
    background: #eb5055;
    border-radius: 5px;
    position: absolute;
    top: 5px;
  }

  .content {
    width: 650px;
    height: 45px;
    font-size: 25px;
    line-height: 45px;
    background: #5b9bd5;
    border: 2px solid rgba(0, 0, 0, .5);
    border-radius: 15px;

    align-self: center;
    justify-self: center;

    img {
      height: 35px;
      vertical-align:middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu_components/Publicity.vue